export const canPasteTreeAsAr = () => () => {
    return function (nodes) {
        const ns = [...nodes].filter(
            node => this.actions.canPasteTreeAsAr(node)
        )

        if (1 === ns.length) {
            return ns
        }
        else {
            return []
        }
    }
}

export const pasteTreeAsAr = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.actions.pasteTreeAsAr(nodes)
        )
    }
}
